import { render } from "./BaseCompareRow.vue?vue&type=template&id=08f1d902"
import script from "./BaseCompareRow.vue?vue&type=script&lang=js"
export * from "./BaseCompareRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__